import * as React from 'react';

import DialogContent from '@mui/material/DialogContent';
import {
  ActionContainer,
  AgreeButton,
  ContentDialogText,
  DialogContainer,
  DialogTitleStyle,
  DisagreeButton,
} from './alert-dialog.styled';

export interface AlertDialogProps {
  openDialogAlert: boolean;
  handleCloseDialogAlert: () => void;
  handleConfirm: () => void;
}

export default function AlertDialog({
  openDialogAlert,
  handleCloseDialogAlert,
  handleConfirm,
}: AlertDialogProps) {
  return (
    <DialogContainer
      open={openDialogAlert}
      onClose={handleCloseDialogAlert}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitleStyle id="alert-dialog-title">
        {'Refaire votre CV ?'}
      </DialogTitleStyle>
      <DialogContent>
        <ContentDialogText>
          En choisissant de créer un nouveau CV vidéo, votre CV actuellement
          existant sera effacé.
        </ContentDialogText>
      </DialogContent>
      <ActionContainer>
        <AgreeButton onClick={handleConfirm} variant="contained">
          Créer un nouveau CV
        </AgreeButton>
        <DisagreeButton
          onClick={handleCloseDialogAlert}
          autoFocus
          variant="contained"
        >
          Annuler
        </DisagreeButton>
      </ActionContainer>
    </DialogContainer>
  );
}
